import { render, staticRenderFns } from "./BtnDownloadDocumento.vue?vue&type=template&id=7a09c882&"
import script from "./BtnDownloadDocumento.vue?vue&type=script&lang=js&"
export * from "./BtnDownloadDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports